import { useTLang } from 'intl/intl';

export function useMainKanbanCardAdoptionLang() {
  const _storeManagerText = useTLang({
    id: 'adoption.storeManager',
  });
  const _storeManagerDisclaimer = useTLang({
    id: 'adoption.storeManagerDisclaimer',
  });
  const _orderReadyText = useTLang({
    id: 'adoption.orderReady',
  });
  const _orderReadyDisclaimer = useTLang({
    id: 'adoption.orderReadyDisclaimer',
  });

  return {
    text: { orderReady: _orderReadyText, storeManager: _storeManagerText },
    disclaimer: {
      orderReadyDisclaimer: _orderReadyDisclaimer,
      storeManager: _storeManagerDisclaimer,
    },
  };
}
